import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { ChoiceGroup } from 'office-ui-fabric-react';

const RadioButtonGroup = ({
  field: { name, value },
  form: { errors = {}, isSubmitting = false, setFieldValue = () => {} },
  options,
  label,
  className,
  ...other
}) => {
  return (
    <ChoiceGroup
      name={name}
      disabled={isSubmitting}
      selectedKey={value}
      options={options}
      onChange={(e, item) => {
        setFieldValue(name, item.key);
      }}
      label={label}
      errorMessage={get(errors, name)}
      className={className}
      {...other}
    />
  );
};

RadioButtonGroup.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    isSubmitting: PropTypes.bool,
    setFieldValue: PropTypes.func,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
};

RadioButtonGroup.defaultProps = {
  className: '',
  label: '',
  form: {
    touched: {},
    errors: {},
    isSubmitting: false,
  },
};

export default RadioButtonGroup;
